import { render } from "./CompleteBooking.vue?vue&type=template&id=70e64769&scoped=true"
import script from "./CompleteBooking.vue?vue&type=script&lang=js"
export * from "./CompleteBooking.vue?vue&type=script&lang=js"

import "./CompleteBooking.vue?vue&type=style&index=0&id=70e64769&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70e64769"]])

export default __exports__